import { render, staticRenderFns } from "./AddTestimonials.vue?vue&type=template&id=b4b85ff0&scoped=true&"
import script from "./AddTestimonials.vue?vue&type=script&lang=js&"
export * from "./AddTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./AddTestimonials.vue?vue&type=style&index=0&id=b4b85ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b85ff0",
  null
  
)

export default component.exports